module.exports=function(scope){ return `curl -X POST \
'https://your.internal.facetec.standard.server.instance.url/match-3d-3d' \
-H 'Content-Type: application/json' \
-H 'X-User-Agent: INSERT_X_USER_AGENT_VALUE_HERE' \
-d '{
    "source": {
        "enrollmentIdentifier": "INSERT_ENROLLMENT_ID_HERE"
    },
    "target": {
        "faceMap": "INSERT_FACEMAP_DATA_AS_BASE64_HERE"
    }
    "auditTrailImage": "INSERT_AUDIT_TRAIL_IMAGE_AS_BASE64_HERE",
    "lowQualityAuditTrailImage": "INSERT_LOW_QUALITY_AUDIT_TRAIL_IMAGE_AS_BASE64_HERE"
}'
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/bash/compare.bash.tpl